interface ViewToggleProps {
    value: 'list' | 'module';
    onChange: (value: 'list' | 'module') => void;
}

export const ViewToggle = ({ value, onChange }: ViewToggleProps) => {
    return (
        <div className="view-toggle">
            <button
                className={`view-toggle__button ${value === 'module' ? 'view-toggle__button--active' : ''}`}
                onClick={() => onChange('module')}
                aria-label="grid view"
            >
                <img src="/svg/grid-view.svg" alt="Grid view" />
            </button>
            <button
                className={`view-toggle__button ${value === 'list' ? 'view-toggle__button--active' : ''}`}
                onClick={() => onChange('list')}
                aria-label="list view"
            >
                <img src="/svg/list-view.svg" alt="List view" />
            </button>
        </div>
    );
};
